import { Injectable } from '@angular/core'
import { Logger } from '../../../logger.service'
import { ApiService } from '../../general/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Revenue } from '../../../models'
import { HttpParams } from '@angular/common/http'
import { LocalStorageService } from '@hmp/helper'

const log = new Logger('RevenueService')

/**
 * Đây là services dành cho RevenueService
 */
@Injectable({ providedIn: 'root' })
export class RevenueService {
  constructor(
    private apiService: ApiService,
    private storage: LocalStorageService
  ) {}
  /**
   * Khai báo tất cả các path sẻ sử dụng
   */
  private _apiPath = {
    list: 'revenue/revenue_entity',
    detail: 'revenue/revenue_entity',
  }

  /**
   * Lấy tất cả Revenue
   */
  getAll(params?: any): Observable<any> {
    let pa = new HttpParams().set(
      'parameters[revenue_business_id]',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }

    return this.apiService.get<any>(this._apiPath.list, pa).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Lấy thông tin chi tiết của Revenue dưạ vào @id
   * @param Id ID của Revenue
   */
  getDetail(id: string): Observable<Revenue> {
    return this.apiService.get<Revenue>(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }

  /**
   * Tạo Revenue
   * @param res Thông tin Revenue
   */
  create(res: Revenue): Observable<any> {
    res.rid = null
    return this.apiService.post(this._apiPath.detail, res).pipe(
      map(data => {
        log.debug(data)
        return
      })
    )
  }

  /**
   * Chỉnh sửa thông tin Revenue
   *
   * @param res Thông tin Revenue muốn chỉnh sửa
   */
  edit(res: Revenue): Observable<any> {
    return this.apiService.put(`${this._apiPath.detail}/${res.rid}`, res).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Xóa thông tin Revenue
   *
   * @param id Xóa Revenue bằng Revenue ID
   */
  delete(id): Observable<any> {
    return this.apiService.delete(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }
}
